import { IApplicationState } from '../../types/redux';

export const selectSuggestionsList = (state: IApplicationState) => state.suggestions.list;
